import type { Address } from 'viem'
import type {
  DepositInstructionsResponse,
  DepositInstructionsResponseEnvelope,
  DepositResponse,
  GetDepositInstructionsQuery,
  ListDepositsQuery,
  ListDepositsResponseEnvelope,
} from '@/hooks/v1'
import { client } from '@/services/api'

type DepositInstructionsParams = {
  quantity: string
  ownerAddress: Address
  nonce: bigint
}

export const getDepositInstructions = async ({
  quantity,
  ownerAddress,
  nonce,
}: DepositInstructionsParams): Promise<DepositInstructionsResponse> => {
  const params: GetDepositInstructionsQuery = {
    quantity,
    owner_address: ownerAddress,
    nonce: nonce.toString(),
  }
  const response = await client<DepositInstructionsResponseEnvelope>({
    method: 'GET',
    url: '/v1/web3/deposit-instructions',
    params,
  })

  if (!response.data?.data) throw new Error('Deposit instructions response did not include data')
  return response.data.data
}

type ListDepositsParams = {
  userId: string
  page: number
  limit: number
  signal?: AbortSignal
}

export const listDeposits = async ({
  userId,
  page,
  limit,
  signal,
}: ListDepositsParams): Promise<DepositResponse[]> => {
  const params: ListDepositsQuery = { user_id: userId, page, limit }
  const response = await client<ListDepositsResponseEnvelope>({
    method: 'GET',
    url: '/v1/web3/deposits',
    params,
    signal,
  })

  // A malformed response is a failed status lookup, not proof that the user has no deposits.
  if (!Array.isArray(response.data?.data)) {
    throw new Error('Deposit status response did not include a deposit array')
  }
  return response.data.data
}
